import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertMessage } from '../../AlertMessage/component';
import { BREAKPOINT_MOBILE } from '../../Style/breakpoints';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_4,
  OL_COLOUR_BLACK_90,
} from '../../Style/colours';
import { MIXIN_ANCHOR_BUTTON } from '../../Style/mixins';
import VideoCorners from '../icons/video-corners.svg';

export const ContentModal = styled('div')({
  marginTop: 20,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  '& > *:not(:last-child)': {
    marginBottom: 20,
  },
});

export const RecordIconNotes = styled('div')({
  img: {
    marginRight: 10,
  },
  span: {
    color: OL_COLOUR_BLACK_90,
    fontWeight: 600,
    fontSize: 16,
    margin: 'auto',
  },
});

export const WebcamWrapper = styled('div')({
  position: 'relative',
  width: 380,
  height: 380,
  video: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 1,
  },
  [`@media (max-width: ${BREAKPOINT_MOBILE})`]: {
    width: 300,
    height: 300,
  },
});

export const FaceMarker = styled('div')({
  position: 'absolute',
  width: '80%',
  height: 242,
  left: '50%',
  top: '50%',
  textAlign: 'center',
  fontSize: 200,
  transform: 'translate(-50%, -50%)',
  backgroundImage: `url(${VideoCorners})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  opacity: 0.7,
  zIndex: 2,
  [`@media (max-width: ${BREAKPOINT_MOBILE})`]: {
    height: 195,
  },
});

export const StartRecordButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  width: 48,
  height: 48,
  img: {
    width: '100%',
  },
});

export const VideoIcon = styled(FontAwesomeIcon)({
  color: 'red',
  marginRight: 10,
});

export const StyledAlertMessage = styled(AlertMessage)({
  margin: 20,
});

export const RecordLabelWrapper = styled('div')({
  background: OL_COLOUR_BLACK_4,
  textAlign: 'center',
  padding: '20px 0',
  width: '100%',
  border: `1px solid ${OL_COLOUR_BLACK_10}`,
});

export const PlaceholderVideo = styled('div')({
  background: '#C4C4C4',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
});
